import { Client } from "../client";
import { batchActions } from "redux-batched-actions";
import {
  SHIRT_DETAILS_REQUEST_FAIL,
  SET_BUILDER_PAGE,
  INIT_SEARCH
} from "../constants/actionTypes";

export function getFabricImagePreview(article) {
  return async (dispatch, getState) => {
    let url;
    try {
      url = await Client.getFabricImageUrl(article);
    } catch (error) {
      dispatch(batchActions([{
        type: SHIRT_DETAILS_REQUEST_FAIL,
        error,
      },
      ]), getState);
      return {
        error
      };
    }
    return url;
  };
}


export function setBuilderPage(payload) {
  return (dispatch) => {
    dispatch({
      type: SET_BUILDER_PAGE,
      payload,
    });
  };
}

export function initSearch(payload) {
  return (dispatch) => {
    dispatch({
      type: INIT_SEARCH,
      payload,
    });
  };
}

export function initContrastSearch(data) {
  return {
    type: 'UPDATE_CONTRAST_SEARCH_TERMS',
    data,
  }
}
